<template>
  <myDialog
    :isDialog="isDialog"
    :title="type === 2 ? '文书管理' : '文书打印'"
    :width="'900px'"
    :isFooter="true"
    @handleClose="handleClose"
  >
    <template #content>
      <div class="document-gen">
        <div class="section-block">
          <div class="section-title">文书生成</div>
          <el-form ref="formRef" :model="form" label-width="120px" :rules="auxRules" class="doc-form">
            <el-form-item label="文书类型" prop="typeCode" required>
              <el-select
                v-model="form.typeCode"
                placeholder="请选择文书类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in documentTypeOptions"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="认定书文号">
              <el-input
                v-model="form.referenceNumber"
                placeholder="例如:1"
                clearable
              />
            </el-form-item>
          </el-form>
          <!-- 文书内容预览 -->
          <div class="preview-wrap" v-if="false">
            <div class="preview-title">文书内容预览</div>
            <div class="preview-content" v-loading="previewLoading">
              <template v-if="previewUrl && isPdfUrl(previewUrl)">
                <iframe
                  :key="previewUrl"
                  :src="resolvePreviewUrl(previewUrl)"
                  class="preview-iframe"
                  title="文书预览"
                />
              </template>
              <template v-else-if="previewUrl && isImageUrl(previewUrl)">
                <img
                  :key="previewUrl"
                  :src="resolvePreviewUrl(previewUrl)"
                  class="preview-img"
                  alt="文书预览"
                />
              </template>
              <div v-else class="preview-empty">
                <span>{{ previewPlaceholder }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <el-button @click="handleSubmit(1)" :loading="refreshLoading">预览</el-button>
      <el-button type="primary" @click="handleSubmit(2)">下载文书</el-button>
      <el-button @click="handleClose">关闭</el-button>
    </template>
  </myDialog>
</template>

<script>
import myDialog from '@/components/myComponents/myDialog/index.vue'
import { getListByDictType } from '@/api/sys/dictData'
import {generateDocument} from "@/api/recognition/survey";
import {downLoadFile, previewFile, getBlobErrorMsg, isBlobErrorResponse} from '@/utils/downLoad'

export default {
  name: 'SendDocumentDialog',
  components: {
    myDialog
  },
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    },
    type:{
      default:2
    }
  },
  data() {
    return {
      form: {
        typeCode: '',
        referenceNumber: '',
        generateType:this.type
      },
      documentTypeOptions: [],
      previewUrl: '',
      previewLoading: false,
      refreshLoading: false,
      auxRules:{
        typeCode:[
          { required: true, message: '请选择文书类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    previewPlaceholder() {
      const typeLabel =
        this.documentTypeOptions.find(
          (o) => String(o.dictValue) === String(this.form.typeCode)
        )?.dictLabel || '工伤认定决定书'
      const num = this.form.referenceNumber || '文号'
      return `预览:${typeLabel} - ${num}`
    }
  },
  watch: {
    isDialog(val) {
      if (val) {
        this.loadDictData()
        this.resetForm()
      }
    }
  },
  created() {
    this.loadDictData()
  },
  methods: {
    async loadDictData() {
      try {
        const res = await getListByDictType(this.type==2?'industrial_injury_case_document_type':'industrial_injury_accept_document_type')
        if (res && res.code === 200 && res.data) {
          this.documentTypeOptions = res.data
        } else {
          this.documentTypeOptions = []
        }
      } catch (e) {
        console.warn('文书类型字典加载失败', e)
        this.documentTypeOptions = []
      }
    },
    resetForm() {
      this.form = {
        typeCode: '',
        referenceNumber: '',
        generateType:this.type
      }
      this.previewUrl = ''
    },
    resolvePreviewUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')) return url
      const prefix = this.imageUrlprefix || process.env.VUE_APP_IMAGEURLPREFIX || ''
      return prefix + url
    },
    isPdfUrl(url) {
      if (!url) return false
      const u = (url || '').toLowerCase()
      return u.includes('.pdf') || u.includes('application/pdf')
    },
    isImageUrl(url) {
      if (!url) return false
      const u = (url || '').toLowerCase()
      return /\.(jpg|jpeg|png|gif|webp)(\?|$)/.test(u) || u.includes('image/')
    },
    handleClose() {
      this.$emit('handleClose')
      this.resetForm()
    },
    handlePreview(response) {
      previewFile(response)
    },
    handleDownloadCurrent(response) {
      downLoadFile(response,this.form.typeName,this.form.referenceNumber)
    },
    handleSubmit(state){
      this.$refs.formRef.validate().then(valid=>{
        if(!valid){
          return
        }
        this.form.type=state;
        this.form.typeName=this.selectDictLabel(this.documentTypeOptions,this.form.typeCode);
        let caseId=this.rowData.id;
        if(!caseId)return;
        this.form.caseId=caseId;
        generateDocument(this.form).then(async (res) => {
          if (isBlobErrorResponse(res)) {
            const errorMsg = await getBlobErrorMsg(res, '文书生成失败')
            return this.$message.error(errorMsg)
          }
          if (res) {
            if (state == 2) {
              this.handleDownloadCurrent(res)
            } else {
              this.handlePreview(res)
            }
          }
        }).catch((error) => {
          console.log(error)
          this.$message.error(error?.message || error?.msg || '文书生成失败')
        }).finally(() => {
          this.handleClose()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.document-gen {
  width: 100%;
}

.section-block {
  padding: 0;
  margin-bottom: 0;
}

.section-title {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding-left: 11px;
  margin-bottom: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: var(--vt-c-blue, #297dee);
  }
}

.doc-form {
  margin-bottom: 16px;
}

.preview-wrap {
  display: flex;
  flex-direction: column;
  min-height: 320px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fafafa;
}

.preview-title {
  padding: 8px 12px;
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.preview-content {
  flex: 1;
  position: relative;
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-iframe {
  width: 100%;
  height: 100%;
  min-height: 280px;
  border: none;
}

.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.preview-empty {
  color: #909399;
  font-size: 14px;
  text-align: center;
  padding: 40px 20px;
}

/* 与 acceptDialog 一致的弹窗头部与表单项样式 */
/deep/ .el-form-item__label {
  color: #2a3347 !important;
  font-weight: 400;
  font-size: 16px;
}

/deep/ .el-dialog__header {
  background: #297dee !important;
}

/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}
</style>
